import React, { Fragment } from "react";
import styled from "styled-components";
// @ts-ignore
import { CWBDropdown, CWBTooltip, moment } from "cwb-react";
import { SectionTitle, StyledBlueBtn } from "../helpers/styles";
import { RouteComponentProps } from "react-router-dom";
import { connect } from "react-redux";
import { withI18n } from 'react-i18next';
import TeamShareComponent from "./TeamShareComponent";
import Modals from "./Modals/Modals";
import AlertMessage from "./Modals/AlertMessage";
import Spinner from "../images/spinner.svg";
import Spinner_Blue from "../images/spinner_blue.svg"

interface IState {
  selectedTS?: any
}

interface IProps extends StateProps, DispatchProps, RouteComponentProps<any> {
  t: any
}

class Schedule extends React.Component<IProps, IState> {
  public state: IState = {
    selectedTS: null
  };

  async componentDidMount() {
    const {requestData} = this.props;
    if (requestData.selectedBd) {
      this.props.loadData({bdId: requestData.selectedBd, isCommercial: requestData.bdType === "2"});
    }
  }

  addSelectedTS = async () => {
    const {selectedTS, openAlertModal} = this.props;
    if (!this.state.selectedTS) {
      openAlertModal({title: '', message: this.props.t('Please select a TeamShare.')})
      return;
    }
    const index = selectedTS.indexOf(this.state.selectedTS.teamShareId);
    if (index > -1) {
      openAlertModal({title: '', message: this.props.t('TeamShare already Added.')})
    } else {
      await this.props.addSelectedTS(this.state.selectedTS.teamShareId);
      await this.props.getTeamShareInfo(this.state.selectedTS);
    }
    await this.setState({selectedTS: null});
  }

  render() {
    const { t, availableTS, selectedTS, requestData, createSchedule, submitSchedule, isLoadingTS, isLoadingTSInfo } = this.props;
    const scheduleDate = moment.moment([requestData.audDataY, requestData.audDataM, requestData.audDataD]);
    const weekDayName = scheduleDate.format('dddd');

    return (
        <Fragment>
          <AlertMessage {...this.props}/>
          <StyledHeader>
            <HeaderTitle>{t('Create a Schedule')}</HeaderTitle>
          </StyledHeader>
          <Wrapper>
            <StyledHeading>
              {t('Build Schedule')}:
              {` ${requestData.scheduleName} ${t("for")} ${weekDayName} ${scheduleDate.format('LL')}`}</StyledHeading>
            <ContentBox>
              <HeaderSection>
                <SectionTitle>{t('Available TeamShares')}:</SectionTitle>
                <CWBDropdown
                    className="account-dropdown"
                    placeholder={t("Select TeamShare")}
                    items={availableTS}
                    getOptionLabel={(option: any) => option.title}
                    getOptionValue={(option: any) => option.teamShareId}
                    value={this.state.selectedTS}
                    onChange={async (option: any) => {
                      await this.setState({selectedTS: null})
                      await this.setState({selectedTS: option})
                    }}
                    isLoading={isLoadingTS}
                    loadingMessage={() => <StyledSpinner src={Spinner_Blue} alt="" />}
                    noOptionsMessage={() => t('No TeamShare available')}
                />
                <div>
                  <AddTSIcon id="add-ts-title" className="icon-cwb-plus-white" onClick={this.addSelectedTS}></AddTSIcon>
                  <CWBTooltip target="add-ts-title" placement={"right"}>{t('Add TeamShare')}</CWBTooltip>
                </div>
                {isLoadingTSInfo && <StyledSpinner src={Spinner_Blue} alt="" style={{marginLeft: '16px'}} />}
              </HeaderSection>
              {selectedTS.map((ts: any) => {
                return <TeamShareComponent key={`${ts}_Component`} teamShareId={ts} {...this.props}/>
              })}
              {selectedTS.length > 0 && this.props.isValid && <StyledBlueBtn style={{width: '220px', margin: '0 auto'}} onClick={createSchedule}>
                {t('Create Schedule')} {submitSchedule && <StyledImg src={Spinner} alt="" />}
                </StyledBlueBtn>}
            </ContentBox>
            <Modals />
          </Wrapper>
        </Fragment>
    );
  }
};

const Wrapper = styled.div`
  width: 80vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 34px auto;
  transition: all 0.3s ease-in-out;
  
 
  *{
    font-size: ${p => p.theme['font-size']};
    color: ${p => p.theme.color};
  }  
	
	.cwb-dropdown-wrapper {
    height: 36px;
    margin-left: 16px;
    
    .cwb-dropdown__single-value{
      font-size: ${p => p.theme['s-font-size']};
      font-weight: ${p => p.theme['font-weight-600']};
    }
    
    .cwb-dropdown__indicator{
      width: 14px;
    }
	}
	
	.cwb-dropdown-wrapper > div {
	  min-width: 320px;
	  max-width: 320px;
	  
	  @media all and (max-width: 720px) {
      min-width: 200px;
      max-width: 200px;
    }
	}
	
	.cwb-dropdown__placeholder{
	  color: ${p => p.theme.darkGrey};
	  font-size: ${p => p.theme['s-font-size']};
	}
	
	.cwb-dropdown-wrapper {
	  > div .cwb-dropdown__control{
      min-height: 36px;
      border: ${props => props.theme.dropDown['border']} !important;
      border-radius: ${props => props.theme.dropDown['border-radius']};
    }
	}
`

const StyledHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;

  height: 95px;
  padding: 15px 0;
  background: ${p => p.theme.white};
  box-shadow: 0 0 1px 0 rgba(10, 31, 68, 0.08),
    0 1px 1px 0 rgba(10, 31, 68, 0.08);
`;

const HeaderTitle = styled.div`
  width: 80vw;
  font-size: 24px;
  font-weight: ${p => p.theme['font-weight']};
  letter-spacing: 0.6px;
  line-height: 32px;
  transition: all 0.3s ease-in-out;
`;

const ContentBox = styled.div`
  width: 100%;
  background: ${p => p.theme.white};
  border: ${p => p.theme.border};
  border-radius: ${p => p.theme.dropDown['border-radius']};
  padding: 40px 64px;
  margin-top: 11px;
  margin-bottom: 34px;
`

const StyledHeading = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  
  font-size: ${p => p.theme['xl-font-size']};
  font-weight: ${p => p.theme['font-weight']};
  letter-spacing: 0.36px;
  line-height: 32px;
`;

const HeaderSection = styled.div`
  width: 100%;
  margin-bottom: 24px;
  
  display: flex;
  align-items: center;
  justify-content: start;
`

const AddTSIcon = styled.div`
  background: ${p => p.theme.btnDarkBlue};
  margin-left: 24px;
  padding: 8px;
  border-radius: 25px;
`

const StyledImg = styled.img`
  width: 16px !important;
  min-height: 16px;
  height: auto;
  margin-left: 8px;
`;

const StyledSpinner = styled.img`
  width: 20px !important;
  min-height: 20px;
  height: auto;
`;

interface StateProps {
  requestData: any,
  availableTS: any,
  selectedTS: any,
  submitSchedule: boolean,
  isLoadingTS: boolean,
  isLoadingTSInfo: boolean,
  isValid: boolean
}

function mapStateToProps(state: any): StateProps {
  let isValid: boolean = false;
  const selectedTsInfo = state.scheduling.selectedTsInfo;
  Object.keys(selectedTsInfo).forEach(function (key) {
    const value = selectedTsInfo[key];
    isValid = value.roles.some((role: any) => {
      return ((role.targetRoleId > -1 || role.isNewRole) && role.options.length > 0);
    })
  });
  return {
    requestData: state.scheduling.requestData,
    availableTS: state.scheduling.availableTS,
    selectedTS: state.scheduling.selectedTS,
    submitSchedule: state.scheduling.submitSchedule,
    isLoadingTS: state.scheduling.isLoadingTS,
    isLoadingTSInfo: state.scheduling.isLoadingTSInfo,
    isValid
  };
}

interface DispatchProps {
  prepareRequestData: () => boolean,
  addSelectedTS: (selectedTS: any) => void,
  getTeamShareInfo: (ts: any) => void,
  openAlertModal: ({title, message, onClick, buttons}: any) => void,
  closeModal: () => void,
  loadData: ({bdId, isCommercial}: any) => void,
  createSchedule: () => void
}

function mapDispatchToProps(dispatch: any): DispatchProps {
  return {
    prepareRequestData: dispatch.scheduling.loadRequestData,
    addSelectedTS: dispatch.scheduling.addSelectedTS,
    getTeamShareInfo: dispatch.scheduling.getTeamShareInfo,
    openAlertModal: dispatch.modal.openAlertModal,
    closeModal: dispatch.modal.closeModal,
    loadData: dispatch.scheduling.loadData,
    createSchedule: dispatch.scheduling.createSchedule
  };
}

export default withI18n()(connect<StateProps, DispatchProps, {}>(mapStateToProps, mapDispatchToProps)(Schedule));
